export const optionsCivility = [
    { value: "Monsieur", label: "Monsieur" },
    { value: "Madame", label: "Madame" }
]